
import './App.css';
import CatalogViewer from './components/CatalogViewer';

function App() {
  return (
    <>
      <div className="App">
        <h3>Catalog Viewer</h3>
      </div>
      <CatalogViewer />
    </>

  );
}

export default App;
